import { Injectable } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';
import { SubjectService } from './subject.service';
import { AppSettings } from '../enums/app-settings.enum';
import { ProductService } from './product.service';
import { ApplicationInitializationService } from './application-initialization.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RoamingSearchOptionsDataService {
  private isPopupOpened = null;
  private selectedRoamingCountries = [];
  private orignalCountryList: any;
  private frequentlyVisitedCountries = [];
  private groupCountry = [];
  private backupCountries: any;
  private countries = [];
  private backupFrequentlyVisitedCountries = [];
  private ROAMING_FREQUENTRLY_VISITED_COUNTRIES: string[] = [];
  private arabicStringList: any[];
  private arabicListSorted: any[];
  private showCountryListOption = false;
  private lang: string;
  private selectedRoamingFilters = [];
  private selectedRoamingSort = [];
  private originalFilter = [];

  constructor(
    private UTS: UtilitiesService,
    private PS: ProductService,
    private SS: SubjectService,
    private APPINITS: ApplicationInitializationService,
    private AR: ActivatedRoute,
    private router: Router
  ) {
    this.lang = this.UTS.getLocaleLanguage().toLowerCase();
    this.setRoamingFrequentlyVistedCountries(
      this.APPINITS.environmentConfig.ROAMING_FREQUENTRLY_VISITED_COUNTRIES
    );
  }
  setPopupOpened(v) {
    this.isPopupOpened = v;
  }

  getPopupOpened() {
    return this.isPopupOpened;
  }

  setShowCountryListOption(v) {
    this.showCountryListOption = v;
  }

  getShowCountryListOption() {
    return this.showCountryListOption;
  }

  setSelectedRoamingCountries(v) {
    this.selectedRoamingCountries = v;
  }

  getSelectedRoamingCountries() {
    return this.selectedRoamingCountries;
  }

  setOrignalCountryList(v) {
    this.orignalCountryList = v;
  }

  getOrignalCountryList() {
    return this.orignalCountryList;
  }

  setFrequentlyVisitedCountries(v) {
    this.frequentlyVisitedCountries = v;
  }

  getFrequentlyVisitedCountries() {
    return this.frequentlyVisitedCountries;
  }

  setGroupCountry(v) {
    this.groupCountry = v;
  }

  getGroupCountry() {
    return this.groupCountry;
  }

  setCountries(v) {
    this.countries = v;
  }

  getCountries() {
    return this.countries;
  }

  getRoamingFrequentlyVistedCountries() {
    return this.ROAMING_FREQUENTRLY_VISITED_COUNTRIES;
  }

  setRoamingFrequentlyVistedCountries(V) {
    this.ROAMING_FREQUENTRLY_VISITED_COUNTRIES = V;
  }

  setSelectedRoamingFilters(v) {
    this.selectedRoamingFilters = v;
  }

  getselectedRoamingFilters() {
    return this.selectedRoamingFilters;
  }

  setSelectedRoamingSort(v) {
    this.selectedRoamingSort = v;
  }

  getselectedRoamingSort() {
    return this.selectedRoamingSort;
  }


  setOriginalFilter(v) {
    this.originalFilter = v;
  }

  getOriginalFilter() {
    return this.originalFilter;
  }
  selectedCountriesUpdateFlag() {
    for (let i = 0; i < this.selectedRoamingCountries?.length; i++) {
      const selectedRoamingCountry = this.selectedRoamingCountries[i];
      for (let j = 0; j < this.countries?.length; j++) {
        for (let k = 0; k < this.countries[j]?.countries?.length; k++) {
          const country = this.countries[j]?.countries[k];
          if (
            country?.id === selectedRoamingCountry?.id &&
            country?.selected == true
          ) {
            this.countries[j].countries[k].selected = false;
          } else if (country?.id === selectedRoamingCountry?.id) {
            this.countries[j].countries[k].selected = true;
          }
        }
      }
    }
  }

  selectedFrequentCountriesUpdateFlag() {
    for (let i = 0; i < this.selectedRoamingCountries?.length; i++) {
      const selectedRoamingCountry = this.selectedRoamingCountries[i];
      for (let j = 0; j < this.frequentlyVisitedCountries?.length; j++) {
        const frequentlyVisitedCountry = this.frequentlyVisitedCountries[j];
        if (
          frequentlyVisitedCountry?.id === selectedRoamingCountry?.id &&
          frequentlyVisitedCountry?.selected == true
        ) {
          this.frequentlyVisitedCountries[j].selected = false;
        } else if (
          frequentlyVisitedCountry?.id === selectedRoamingCountry?.id
        ) {
          this.frequentlyVisitedCountries[j].selected = true;
        }
      }
    }
  }

  countryFilterInitiate() {
    this.lang = this.UTS.getLocaleLanguage().toLowerCase();
    if (this.selectedRoamingCountries?.length > 0) {
      let selectedCountryName = '';
      if (this.lang == 'ar') {
        selectedCountryName = this.selectedRoamingCountries
          ?.map((x) => x?.nameAr)
          .join('+');
      } else {
        selectedCountryName = this.selectedRoamingCountries
          ?.map((x) => this.UTS.capitalizeFirstLetter(x?.countryName))
          .join('+');
      }
      this.SS.onCountrySelectionChange.next({
        No: '0',
        Nrpp: '200',
        categoryId: 'cat1590026',
        Ntk: 'sku.roamingCountries.countryName',
        Ntt: selectedCountryName,
        Ns: 'product.isPopular|1||sku.isPopular|1||product.displayOrder|0||sku.displayOrder|0',
      });
    } else {
      this.SS.resetFilter.next(true);
      this.SS.selectedFilter.next({
        NS: AppSettings.RESET_FILTER,
        C: 0,
        SF: null,
      });
      this.AR.queryParams.subscribe((q) => {
        if (q && q.categoryDimension && q.subCategory) {
          const SC = q.subCategory;
          const CD = q.categoryDimension;
          this.SS.resetFilter.next(true);
          // this.redirectRoute(SC, CD);
          this.SS.resetRoamingToOriginalFilter.next(this.getOriginalFilter());
        }
      });
    }
  }

  async groupCountries() {
    this.lang = this.UTS.getLocaleLanguage().toLowerCase();
    const orignalCountryList = JSON.parse(
      JSON.stringify(this.orignalCountryList)
    );
    for (
      let i = 0;
      i < this.ROAMING_FREQUENTRLY_VISITED_COUNTRIES?.length;
      i++
    ) {
      for (let j = 0; j < this.orignalCountryList?.length; j++) {
        if (
          this.ROAMING_FREQUENTRLY_VISITED_COUNTRIES[i] &&
          this.orignalCountryList[j] &&
          this.orignalCountryList[j]?.countryName &&
          this.ROAMING_FREQUENTRLY_VISITED_COUNTRIES[i]
            ?.toLowerCase()
            .includes(this.orignalCountryList[j]?.countryName?.toLowerCase())
        ) {
          delete orignalCountryList[j];
        }
      }
    }
    if (this.lang == 'en') {
      let data = await orignalCountryList
        ?.filter((x) => x != null)
        .reduce((r, e) => {
          let group = e && e.countryName[0];
          if (!r[group]) r[group] = { group, countries: [e] };
          else r[group].countries.push(e);
          return r;
        }, {});
      this.groupCountry = Object.values(data);
    } else {
      const collator = new Intl.Collator('ar');
      this.arabicListSorted = this.arabicStringList.sort(collator.compare);
      let temp = this.arabicListSorted[0];
      this.arabicListSorted.splice(0, 1);
      this.arabicListSorted.splice(127, 0, temp);
      let tempGrouping = [];
      this.arabicListSorted.forEach((element) => {
        tempGrouping.push(
          orignalCountryList
            ?.filter((x) => x != null)
            .filter((ele) => ele?.nameAr == element)[0]
        );
      });
      let data = tempGrouping.reduce((r, e) => {
        let group = e && e.nameAr[0];
        if (!r[group]) r[group] = { group, countries: [e] };
        else r[group].countries.push(e);
        return r;
      }, {});
      this.groupCountry = Object.values(data);
      this.groupCountry[15].countries.push(this.groupCountry[18].countries[0]);
      this.groupCountry.splice(18, 1);
    }
    this.setCountries(this.groupCountry);
    this.backupCountries = JSON.parse(JSON.stringify(this.groupCountry));
    this.selectedCountriesUpdateFlag();
    this.selectedFrequentCountriesUpdateFlag();
  }

  async getRoamingCountriesList() {
    this.groupCountry = [];
    this.frequentlyVisitedCountries = [];
    this.arabicStringList = [];
    this.arabicListSorted = [];
    this.PS.getRoamingCountriesList('200001').subscribe(async (res: any) => {
      this.setOrignalCountryList(res?.countries);
      this.orignalCountryList = await res?.countries?.sort((a, b) =>
        a.countryName.toLowerCase().localeCompare(b.countryName.toLowerCase())
      );
      res?.countries?.forEach((ele) => this.arabicStringList.push(ele.nameAr));
      this.groupCountries();
      this.configureFrequentlyVisited(res?.countries);
    });
  }

  async configureFrequentlyVisited(countries) {
    await this.ROAMING_FREQUENTRLY_VISITED_COUNTRIES.forEach(async (ele) => {
      let country = await countries.filter(
        (x) => x.countryName.toLowerCase() == ele.toLowerCase()
      );
      if (country?.length > 0) this.frequentlyVisitedCountries.push(country[0]);
    });
    this.backupFrequentlyVisitedCountries =
      this.getFrequentlyVisitedCountries();
    this.selectedFrequentCountriesUpdateFlag();
  }

  async filterList(evt) {
    this.lang = this.UTS.getLocaleLanguage().toLowerCase();
    this.setCountries(JSON.parse(JSON.stringify(this.backupCountries)));
    this.frequentlyVisitedCountries = JSON.parse(
      JSON.stringify(this.backupFrequentlyVisitedCountries)
    );
    const searchTerm = evt?.srcElement?.value;
    if (!searchTerm) {
      return;
    }
    if (this.lang == 'ar') {
      this.setCountries(
        this.getCountries().filter((data: any) => {
          data.countries = data.countries.filter((ele: any) => {
            if (ele?.nameAr && searchTerm) {
              return ele.nameAr.indexOf(searchTerm.toLowerCase()) > -1;
            }
          });
          return data;
        })
      );
      this.frequentlyVisitedCountries = this.frequentlyVisitedCountries.filter(
        (data: any) => {
          if (
            data?.nameAr &&
            searchTerm &&
            data?.nameAr?.indexOf(searchTerm.toLowerCase()) > -1
          ) {
            return data;
          }
        }
      );
      this.selectedCountriesUpdateFlag();
      this.selectedFrequentCountriesUpdateFlag();
    } else {
      this.setCountries(
        this.getCountries().filter((data: any) => {
          data.countries = data.countries.filter((ele: any) => {
            if (ele.countryName && searchTerm) {
              return (
                ele.countryName
                  .toLowerCase()
                  .indexOf(searchTerm.toLowerCase()) > -1
              );
            }
          });
          return data.countries.length > 0 ? true : false;
        })
      );
      this.frequentlyVisitedCountries = this.frequentlyVisitedCountries.filter(
        (data: any) => {
          if (data?.countryName && searchTerm) {
            return (
              data?.countryName
                ?.toLowerCase()
                ?.indexOf(searchTerm.toLowerCase()) > -1
            );
          }
        }
      );
    }
    this.selectedCountriesUpdateFlag();
    this.selectedFrequentCountriesUpdateFlag();
  }

  async selectCountryOption(id, C) {
    if (
      (await this.selectedRoamingCountries?.filter((x) => x?.id == id)
        ?.length) > 0
    ) {
      this.setSelectedRoamingCountries(
        await this.selectedRoamingCountries.filter((x) => x?.id != id)
      );
    } else {
      this.selectedRoamingCountries?.push(C);
    }
    this.countryFilterInitiate();
  }

  async removeSelectedCountry(id, C) {
    if (C) {
      this.setSelectedRoamingCountries(
        await this.selectedRoamingCountries.filter((x) => x?.id != id)
      );
    }
    if (this.getShowCountryListOption() == false) {
      this.setCountries([]);
      this.setFrequentlyVisitedCountries([]);
      this.groupCountries();
      this.configureFrequentlyVisited(this.getOrignalCountryList());
      this.selectedFrequentCountriesUpdateFlag();
      await this.countries?.forEach(async (x, i) => {
        await x?.countries?.forEach(async (y, j) => {
          this.countries[i]['countries'][j]['selected'] = false;
          await this.selectedRoamingCountries?.forEach(async (z) => {
            if (z?.id === y?.id) {
              this.countries[i]['countries'][j]['selected'] = true;
            }
          });
        });
      });

      await this.frequentlyVisitedCountries?.forEach(async (x, i) => {
        this.frequentlyVisitedCountries[i]['selected'] = false;
        await this.selectedRoamingCountries?.forEach(async (z, j) => {
          if (z?.id === x?.id) {
            this.frequentlyVisitedCountries[i]['selected'] = true;
          }
        });
      });
    }
    this.countryFilterInitiate();
  }

  redirectRoute(subCategory: string, categoryDimension?: string) {
    if (subCategory && categoryDimension) {
      this.router.navigateByUrl(
        '/addons?subCategory=' +
          subCategory +
          '&categoryDimension=' +
          categoryDimension +
          '&lang=' +
          this.lang
      );
      document?.location?.reload();
    } else {
      this.router.navigateByUrl(
        '/addons?subCategory=' + subCategory + '&lang=' + this.lang
      );
    }
  }

  checkSelectedRoamingFilterAlredyAddedInFilters(F) {
    let found = false;
    for (let i = 0; i < this.selectedRoamingFilters?.length; i++) {
      const selectedRoamingFilter = this.selectedRoamingFilters[i];
      if (selectedRoamingFilter?.dimensionValueID == F?.dimensionValueID) {
        found = true;
      }
    }
    return found;
  }

  checkSelectedRoamingFilterAlredyAddedInSort(F) {
    let found = false;
    for (let i = 0; i < this.selectedRoamingSort?.length; i++) {
      const selectedRoamingSort = this.selectedRoamingSort[i];
      if (selectedRoamingSort?.dimensionValueID == F?.dimensionValueID) {
        found = true;
      }
    }
    return found;
  }

  checkSelectedRoamingFilterAlreadyExisted(f: any, filter_type: any) {
    if (this.getSelectedRoamingCountries()?.length > 0) {
      if (
        filter_type == 'sku.sort' &&
        this.checkSelectedRoamingFilterAlredyAddedInSort(f) == false
      ) {
        const selectedRoamingSort = this.getselectedRoamingSort();
        selectedRoamingSort.push(f);
        this.setSelectedRoamingSort(selectedRoamingSort);
      } else if (
        filter_type != 'sku.sort' &&
        this.checkSelectedRoamingFilterAlredyAddedInFilters(f) == false
      ) {
        const selectedRoamingFilters = this.getselectedRoamingFilters();
        selectedRoamingFilters.push(f);
        this.setSelectedRoamingFilters(selectedRoamingFilters);
      } else if (
        filter_type == 'sku.sort' &&
        this.checkSelectedRoamingFilterAlredyAddedInSort(f)
      ) {
        this.setSelectedRoamingSort([]);
      } else if (
        filter_type != 'sku.sort' &&
        this.checkSelectedRoamingFilterAlredyAddedInFilters(f)
      ) {
        let selectedRoamingFilters = this.getselectedRoamingFilters();
        selectedRoamingFilters.splice(
          0,
          this.getselectedRoamingFilters()?.indexOf(
            (x) => x?.dimensionValueID == f?.dimensionValueID
          ),
          1
        );
        this.setSelectedRoamingFilters(selectedRoamingFilters);
      }
    }
  }
}
